'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Created by zyy on 2018/4/27.
                                                                                                                                                                                                                                                                   */


var _redux = require('redux');

var _home = require('../actions/home');

var INITIAL_STATE = {
  count: []
};

var counts = function counts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _home.RECEIVE_HOME_DATA:
      return _extends({}, state, {
        count: action.orderCount
      });
    case _home.FAILURE_COUNTS:
      return _extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

var INITIAL_BANNER = [];

var banners = function banners() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_BANNER;
  var action = arguments[1];

  switch (action.type) {
    case _home.RECEIVE_BANNER_DATA:
      return _extends({}, state, {
        items: action.banners
      });
    case _home.FAILURE_FETCH_BANNERS:
      return _extends({}, state, {
        error: action.error
      });
    default:
      return state;
  }
};

var homeReducer = (0, _redux.combineReducers)({
  counts: counts,
  banners: banners
});

exports.default = homeReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/home.js
// module id = 913
// module chunks = 0